import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export const usePortfolio = () => {
  const [portfolioItems, setPortfolioItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPortfolio = async () => {
    try {
      setLoading(true);

      const { data, error } = await supabase
        .from('portfolio')
        .select('*');

      if (error) throw error;

      setPortfolioItems(data || []);
    } catch (error) {
      console.error('Erro ao buscar portfólio:', error);
      setPortfolioItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPortfolio();
  }, []);

  return {
    portfolioItems,
    loading,
    refreshPortfolio: fetchPortfolio,
  };
};